document.addEventListener("DOMContentLoaded", () => {
  if (typeof gsap !== 'undefined') {
    const tl = gsap.timeline({ defaults: { ease: "power1.inOut" } });
    tl.to(".background", { rotation: -20, duration: 1.2 }, 0)
      .to(".black-slide h1.theme-heading", { transform: "translate(0, 0)", duration: 1.2 }, 0)
      .to(".main-banner-second", { transform: "translate(0, 0)", duration: 1.2 }, 0)
      .to(".main-banner-third", { transform: "translate(0, 0)", duration: 1.2 }, 0)
      .to("sticky-header.header-wrapper", { transform: "translate(0, 0)", duration: 1.1 }, 0)
      .to(".main-banner .mb-right", { opacity: 1, transform: "translate(0, 0)", duration: 1.1 }, 0);
  }
});

jQuery(document).ready(function () {

  jQuery(window).scroll(function () {
    var sticky = jQuery('sticky-header.header-wrapper'),
      scroll = jQuery(window).scrollTop();
    if (scroll > 50) sticky.addClass('fixed');
    else sticky.removeClass('fixed');
  });

  /**** Slick Slider ****/

  jQuery('.feat-products-list').slick({
    dots: false,
    arrows: false,
    autoplay: true,
    loop: false,
    infinite: false,
    speed: 800,
    slidesToShow: 3,
    slidesToScroll: 1,
    prevArrow: '<div class="slick-prev"><i class="fal fa-angle-left"></i></div>',
    nextArrow: '<div class="slick-next"><i class="fal fa-angle-right"></i></div>',
    responsive: [
      { breakpoint: 1200, settings: { slidesToShow: 2, slidesToScroll: 1 } },
      { breakpoint: 1024, settings: { slidesToShow: 2, slidesToScroll: 1 } },
      { breakpoint: 768,  settings: { slidesToShow: 1, slidesToScroll: 1 } },
      { breakpoint: 480,  settings: { slidesToShow: 1, slidesToScroll: 1 } }
    ]
  });

  jQuery('.main-testimonial').slick({
    dots: true,
    arrows: false,
    autoplay: true,
    loop: true,
    infinite: true,
    speed: 800,
    slidesToShow: 2,
    slidesToScroll: 1,
    prevArrow: '<div class="slick-prev"><i class="fal fa-angle-left"></i></div>',
    nextArrow: '<div class="slick-next"><i class="fal fa-angle-right"></i></div>',
    responsive: [
      { breakpoint: 1200, settings: { slidesToShow: 2, slidesToScroll: 1 } },
      { breakpoint: 1024, settings: { slidesToShow: 2, slidesToScroll: 1 } },
      { breakpoint: 768,  settings: { slidesToShow: 1, slidesToScroll: 1 } },
      { breakpoint: 480,  settings: { slidesToShow: 1, slidesToScroll: 1 } }
    ]
  });

  jQuery('.burning-collection-list').slick({
    dots: false,
    arrows: false,
    autoplay: false,
    loop: true,
    infinite: true,
    speed: 800,
    slidesToShow: 2,
    slidesToScroll: 1,
    prevArrow: '<div class="slick-prev"><i class="fal fa-angle-left"></i></div>',
    nextArrow: '<div class="slick-next"><i class="fal fa-angle-right"></i></div>',
    responsive: [
      { breakpoint: 1200, settings: { slidesToShow: 2, slidesToScroll: 1 } },
      { breakpoint: 1024, settings: { slidesToShow: 2, slidesToScroll: 1 } },
      { breakpoint: 768,  settings: { slidesToShow: 1, slidesToScroll: 1 } },
      { breakpoint: 480,  settings: { slidesToShow: 1, slidesToScroll: 1 } }
    ]
  });

  jQuery(function ($) {
    var path = window.location.href;
    jQuery('ul.list-menu li').each(function () {
      if (this.href === path) {
        jQuery(this).addClass('header__active-menu-item');
      }
    });
  });

  /* countTo plugin */
  (function ($) {
    $.fn.countTo = function (options) {
      options = options || {};
      return $(this).each(function () {
        var settings = $.extend({}, $.fn.countTo.defaults, {
          from: $(this).data('from'),
          to: $(this).data('to'),
          speed: $(this).data('speed'),
          refreshInterval: $(this).data('refresh-interval'),
          decimals: $(this).data('decimals')
        }, options);
        var loops = Math.ceil(settings.speed / settings.refreshInterval),
          increment = (settings.to - settings.from) / loops;
        var self = this,
          $self = $(this),
          loopCount = 0,
          value = settings.from,
          data = $self.data('countTo') || {};
        $self.data('countTo', data);
        if (data.interval) clearInterval(data.interval);
        data.interval = setInterval(updateTimer, settings.refreshInterval);
        render(value);
        function updateTimer() {
          value += increment;
          loopCount++;
          render(value);
          if (typeof settings.onUpdate == 'function') settings.onUpdate.call(self, value);
          if (loopCount >= loops) {
            $self.removeData('countTo');
            clearInterval(data.interval);
            value = settings.to;
            if (typeof settings.onComplete == 'function') settings.onComplete.call(self, value);
          }
        }
        function render(value) {
          var formattedValue = settings.formatter.call(self, value, settings);
          $self.html(formattedValue);
        }
      });
    };
    $.fn.countTo.defaults = {
      from: 0, to: 0, speed: 1000, refreshInterval: 100, decimals: 0,
      formatter: function (value, settings) { return value.toFixed(settings.decimals); },
      onUpdate: null, onComplete: null
    };
  }(jQuery));

  jQuery(function ($) {
    $('.count-number').data('countToOptions', {
      formatter: function (value, options) {
        return value.toFixed(options.decimals).replace(/\B(?=(?:\d{3})+(?!\d))/g, ',');
      }
    });
    $('.timer').each(function () {
      var $this = $(this);
      var options = $.extend({}, $this.data('countToOptions') || {});
      $this.countTo(options);
    });
  });

  /* Suggestion counter (requires anime.js) */
  if (typeof anime !== 'undefined') {
    function countup(el, target) {
      var data = { count: 0 };
      anime({
        targets: data,
        count: [target - 200, target],
        duration: 800,
        round: 1,
        delay: 200,
        easing: 'easeOutCubic',
        update: function () { el.innerText = data.count.toLocaleString(); }
      });
    }
    function makeCountup(el) {
      var target = parseInt(el.textContent, 10);
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.intersectionRatio > 0) {
            countup(el, target);
            io.unobserve(entry.target);
          }
        });
      });
      io.observe(el);
    }
    document.querySelectorAll('.count').forEach(makeCountup);
  }

});
